require('./bootstrap');
require('./lib/common.js');


import LocalFlorist from './components/mapping/local-florists.vue';
import BusinessListings from './components/mapping/business-listings.vue';
import BusinessProfileMap from './components/mapping/business-profile.vue';
import BusinessProfilePanorama from './components/mapping/business-profile-panorama.vue';
import FloristProfile from './components/mapping/florist-profile.vue';
import LocalCommunity from './components/mapping/local-community.vue';

//Components
Vue.component('local-florist-map', LocalFlorist);
Vue.component('business-listings-map', BusinessListings);
Vue.component('business-profile-map', BusinessProfileMap);
Vue.component('business-profile-panorama', BusinessProfilePanorama);
Vue.component('florist-profile-map', FloristProfile);
Vue.component('local-community-map', LocalCommunity);

Vue.config.devtools = false;

const map = new Vue({
    el: '#app',
});


// WEBPACK FOOTER //
// ./src/app.js